import React from 'react';
import { Banner, Layout, Paragraph, ParagraphHeader } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

export type EngagementsViewStateBannerInterviewingCancelledProps = {
  engagement: CandidateEngagementDetails;
  name?: string;
};

export const EngagementsViewStateBannerInterviewingCancelled: React.FC<
  EngagementsViewStateBannerInterviewingCancelledProps
> = ({
  engagement,
  name = 'ENGAGEMENTS_VIEW_STATE_BANNER_INTERVIEWING_CANCELLED',
}) => {
  return (
    <Banner name={name} type="critical" impact="high">
      <Layout direction="vertical" verticalGutter="24px">
        <ParagraphHeader name="INTERVIEWING_CANCELLED_HEADER">
          Interview Canceled: Next Steps
        </ParagraphHeader>
        <Paragraph name="INTERVIEWING_CANCELLED_MESSAGE_1">
          We're working with the client to determine next steps and will update
          you as soon as we know more. Please watch your calendar for possible
          rescheduling.
        </Paragraph>
        <Paragraph name="INTERVIEWING_CANCELLED_MESSAGE_2">
          Cancellations can happen for a few reasons, most commonly due to a
          change in client availability, interview format, or opportunity
          status.
        </Paragraph>
      </Layout>
    </Banner>
  );
};
